import { Typography } from 'src/app/components/Elements/Typography';

import { ShowYourDoctorHeader } from './styles';

export const Header = () => {
  return (
    <ShowYourDoctorHeader>
      <Typography variant="h1" marginBottom={'s5'}>
        Any doctor can send prescriptions to Capsule
      </Typography>
      <Typography variant="body">
        Just tell them &#8220;Capsule&#8221; is your pharmacy. We&#8217;ll text you within an hour to schedule delivery
      </Typography>
    </ShowYourDoctorHeader>
  );
};
